(function () {
    'use strict';

    angular.module('mgpCorregedoriaApp').factory('jsog', Jsog);

    function Jsog() {
        return JSOG;
    }
})();
